import styled from "@emotion/styled";

import { theme } from "shared/lib/styles";

import { GenericArticle } from "scmp-app/components/article/article-render/generic-article";
import { StyledArticleContentRightSection } from "scmp-app/components/article/article-render/generic-article/styles";

export const StyledGenericArticle = styled(GenericArticle)`
  ${theme.breakpoints.up("desktop")} {
    grid:
      "header-ad header-ad header-ad header-ad" min-content
      ". header-container header-container header-container" min-content
      ". leading leading leading" min-content
      ". content-container . right" min-content
      ". . . right" min-content
      ". widgets-bottom widgets-bottom widgets-bottom" min-content
      / minmax(0, 92px) minmax(650px, 776px) 40px 300px;
  }

  ${StyledArticleContentRightSection} {
    margin-block-start: 0;
  }
`;
